import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
// import { editBlog, editSeoRedirect, getSeoRedirect } from "store/actions";
import { useParams } from "react-router-dom";
import Loader from "components/shared/Loader";
import { toast } from "react-toastify";
import { cleanUrl } from ".";
import { editSeoRedirect, getSeoRedirect } from "store/actions/seoRedirects";
import { useHistory } from "react-router-dom";
import { updateMeta } from "store/actions/metaAction";

const EditSeoRedirect = () => {
	const dispatch = useDispatch();
	// const navigate = useNavigate();
	const history = useHistory();
	const navigate = history.push;
	const { id } = useParams();

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل لينك اعادة التوجيه",
				breadcrumb: "لينكات اعادة التوجيه",
				button: {
					show: false,
				},
			})
		);
	};

	const { register, handleSubmit, reset, setValue } = useForm();

	const { singleSeoRedirect, loading, error } = useSelector(
		state => state.seoRedirects
	);

	useEffect(() => {
		dispatch(getSeoRedirect(id));
	}, [dispatch, id]);

	useEffect(() => {
		reset(singleSeoRedirect);
	}, [reset, singleSeoRedirect]);

	useEffect(() => {
		if (error) toast.error(`${error}`);
	}, [error]);

	const onSubmit = data => {
		dispatch(editSeoRedirect({ id, data, navigate }));
	};

	if (loading) return <Loader />;

	return (
		<>
			<div className="acc-form">
				<div className="card">
					<div className="card-body">
						<form onSubmit={handleSubmit(onSubmit)}>
							<Col lg={12} md={12}>
								<Row>
									<Col xs={12}>
										<div className="form-item">
											<label>
												المصدر
												<small style={{ fontSize: "12px" }}>
													{" *"}
													برجاء اضافة العنوان القصير
												</small>
											</label>
											<textarea
												name="source"
												{...register("source", {
													required: true,
													onBlur: e => {
														let val = cleanUrl(e.target.value);
														if (val?.[val?.length - 1] === "/")
															val = val?.slice(0, -1);

														setValue("source", val);
													},
												})}
												dir="ltr"
												rows="5"
											></textarea>
										</div>
									</Col>

									<Col xs={12}>
										<div className="form-item">
											<label>الهدف</label>
											<textarea
												name="destination"
												{...register("destination", { required: true })}
												dir="ltr"
												rows="5"
											></textarea>
										</div>
									</Col>

									<Col xs={12}>
										<div className="form-item">
											<label>كود اعادة التوجيه</label>
											<input
												type="number"
												name="redirectCode"
												{...register("redirectCode", { required: true })}
											/>
										</div>
									</Col>

									<Col lg={4} xs={12}>
										<div className="form-item">
											<button type="submit" className="bt bt-success btn-block">
												حفظ التعديلات
											</button>
										</div>
									</Col>
								</Row>
							</Col>
						</form>
					</div>
				</div>
			</div>
		</>
	);
};

export default EditSeoRedirect;
